<template>
  <section class="products-container" id="drop-zone">
    <section class="collection-text">
      <div class="title-holder">
        <back-button class="back-btn"></back-button>
        <ol class="crumb-path">
          <li>
            <router-link
              class="link"
              :to="{
                name: 'printStore'
              }"
              v-if="!hideRijnjaContent"
            >
              <span>Signing</span>
              <!--  <span v-else>{{ printStoreTitle }}</span> -->

              <inline-svg
                src="/images/icons/chevron-right-solid.svg"
                class="crumb-path-divider"
              ></inline-svg>
            </router-link>
          </li>
          <li>
            <router-link
              class="link"
              :to="{
                name: 'printStoreCategory',
                params: { categoryId: this.$route.params.categoryId }
              }"
            >
              {{ categoryName }}
              <inline-svg
                src="/images/icons/chevron-right-solid.svg"
                class="crumb-path-divider"
              ></inline-svg>
            </router-link>
          </li>
          <li>
            <h1>{{ collection.name }}</h1>
          </li>
        </ol>
        <h1 class="mob-h1">{{ collection.name }}</h1>
        <!--  <authorization-component print-store-role="ADMIN" class="admin-btns">
          <template>
            <print-store-product-upload
              :collection-id="collectionId"
              title="Ontwerpen toevoegen"
              size="small"
            ></print-store-product-upload>
            <toggle @action="selectAll" :active="allSelected"></toggle>
          </template>
        </authorization-component> -->
      </div>
      <p v-if="collection.description" v-html="collection.description"></p>
    </section>

    <empty-text
      v-if="status === 'empty'"
      :title="emptyTitle"
      :text="emptySubtitle"
    >
      <authorization-component print-store-role="ADMIN" class="buttons">
        <print-store-product-upload
          :collection-id="collection.id"
          title="Ontwerpen toevoegen"
        ></print-store-product-upload>
      </authorization-component>
    </empty-text>

    <card-holder v-model="collection.products" v-if="status === 'filled'">
      <product-card
        v-for="product in collection.products"
        :value="product"
        :key="product.id"
        @removed="removeItem(product.id)"
      >
        <template v-slot:header v-if="isOwnPrintStore(product.printStoreId)">
          <authorization-component print-store-role="ADMIN">
            <section class="card-button-holder">
              <template v-if="itemIsInCart(product)">
                <!-- NOTE: slot in parent component should be empty in this case-->
              </template>
              <template v-else>
                <select-box
                  class="select"
                  @action="selectProduct(product)"
                  :selected="selectedProductIds.includes(product.id)"
                ></select-box>
                <popup-menu
                  anchor-position="top-right"
                  v-show="
                    selectedProductIds.includes(product.id) ||
                    selectedProductIds.length < 1
                  "
                >
                  <button class="kebab-btn" slot="trigger">
                    <span></span>
                  </button>
                  <template v-slot:title v-if="selectedProductIds.length > 1"
                    >{{ selectedProductIds.length }} geselecteerde ontwerpen
                  </template>
                  <menu-item
                    @click="showProductSettings(product)"
                    v-if="selectedProductIds.length <= 1"
                    >Wijzigen
                  </menu-item>
                  <menu-item
                    @click="editMultipleProductTypes()"
                    v-if="selectedProductIds.length > 1"
                    >Product wijzigen
                  </menu-item>
                  <menu-item
                    @click="editMultipleDescriptions()"
                    v-if="selectedProductIds.length > 1"
                    >Beschrijving wijzigen
                  </menu-item>
                  <menu-item
                    v-if="selectedProductIds.length === 0 && product.image"
                    @click="download(product)"
                    >Downloaden
                  </menu-item>

                  <menu-item
                    v-if="selectedProductIds.length > 1"
                    @click="deleteProducts(selectedProductIds)"
                    >Verwijderen
                  </menu-item>
                  <menu-item v-else @click="deleteProduct(product)"
                    >Verwijderen
                  </menu-item>
                </popup-menu>
              </template>
            </section>
          </authorization-component>
        </template>
      </product-card>

      <product-request v-if="!hideProductRequest"></product-request>
    </card-holder>
  </section>
</template>
<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import PrintStoreMixin from '../PrintStoreMixin'
import PrintStoreProductUpload from '@/features/printstore/PrintStoreProductUpload.vue'
import {
  getCollectionContent,
  displayOrder,
  clearDisplayOrder
} from '@/features/printstore/PrintStoreApi'
import { EventBus, Events } from '@/eventbus/EventBus'
import ProductSettings from './ProductSettings.vue'
import EditMultipleProductTypes from '@/features/printstore/dialogs/EditMultipleProductTypes.vue'
import EditMultipleDescriptions from '@/features/printstore/dialogs/EditMultipleDescriptions.vue'
import ProductCard from '@/features/printstore/children/ProductCard.vue'
import EmptyText from './EmptyText.vue'
import BackButton from './BackButton.vue'
import Toggle from '@/components/ui/Toggle.vue'
import ProductRequest from './ProductRequest.vue'

export default {
  components: {
    ProductCard,
    PrintStoreProductUpload,
    EmptyText,
    BackButton,
    Toggle,
    ProductRequest
  },
  mixins: [PrintStoreMixin],
  props: ['categoryId', 'collectionId'],
  head() {
    let meta = [
      {
        name: 'description',
        content: this.collection.description
      },
      {
        property: 'og:description',
        content: this.collection.description
      },
      {
        property: 'og:title',
        content:
          this.collection.name +
          ' - Signing | Koninklijke Rijnja - Prints voor professionals'
      },
      {
        property: 'og:url',
        content: this.$route.path
      }
    ]

    if (!this.collection.active || this.status === 'empty') {
      meta.push({ name: 'robots', content: 'noindex' })
    }

    return {
      title:
        this.collection.name +
        ' - Signing | Koninklijke Rijnja - Prints voor professionals',
      meta: meta,
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Signing',
                item: 'https://www.rijnja.nl/printstore'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: this.categoryName,
                item:
                  'https://www.rijnja.nl/printstore/category/' + this.categoryId
              },
              {
                '@type': 'ListItem',
                position: 3,
                name: this.collection.name
              }
            ]
          })
        }
      ]
    }
  },
  data() {
    return {
      selectedProductIds: [],
      status: '',
      collection: {
        products: [],
        name: ''
      }
    }
  },
  created() {
    EventBus.on(Events.PRINT_STORE_UPLOAD_COMPLETE, this.refresh)
    EventBus.on(Events.COLLECTION_UPDATED, this.refresh)
  },
  unmounted() {
    EventBus.off(Events.PRINT_STORE_UPLOAD_COMPLETE)
    EventBus.off(Events.COLLECTION_UPDATED)
  },
  beforeDestroy() {
    this.printStoreStore.currentCollectionName = ''
  },
  async mounted() {
    await this.refresh()
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    cart() {
      return this.printStoreStore.orderDetails.cart
    },
    emptySubtitle() {
      return (this.rootStore.user.printStore &&
        this.rootStore.user.printStore.role) === 'ADMIN'
        ? 'U kunt ontwerpen toevoegen door ze hier te slepen of klik op ontwerpen toevoegen.'
        : ''
    },
    emptyTitle() {
      return 'Deze collectie is nog leeg'
    },
    allSelected() {
      return this.selectedProductIds.length ===
        this.collection.products.length && this.selectedProductIds.length > 0
        ? true
        : false
    },
    categoryName() {
      if (this.$route.params.categoryId === 'shared') {
        return 'Aanbevolen'
      }
      let category = this.printStoreStore.getCategory(
        this.$route.params.categoryId
      )
      return category ? category.name : ''
    }
  },
  methods: {
    async refresh() {
      this.collection = await getCollectionContent(this.collectionId)
      this.status =
        this.collection.products && this.collection.products.length > 0
          ? 'filled'
          : 'empty'

      this.printStoreStore.currentCollectionName = this.collection.name

      if (this.$route.query.product) {
        this.product = this.collection.products.find(
          (product) => product.id === this.$route.query.product
        )
      }

      this.selectedProductIds = []
    },
    selectProduct(product) {
      if (!this.selectedProductIds.includes(product.id)) {
        this.selectedProductIds.push(product.id)
      } else {
        this.selectedProductIds.splice(
          this.selectedProductIds.indexOf(product.id),
          1
        )
      }
    },
    showProductSettings(product) {
      this.$modal.show(
        ProductSettings,
        {
          product: product,
          callback: async () => {
            setTimeout(() => this.refresh(), 500)
          }
        },
        { height: 530, width: 832, adaptive: true, classes: 'transparent' }
      )
    },
    editMultipleProductTypes() {
      this.$modal.show(
        EditMultipleProductTypes,
        {
          productIds: this.selectedProductIds,
          callback: () => {
            setTimeout(() => this.refresh(), 500)
          }
        },
        {
          height: 'auto',
          width: 350,
          adaptive: true
        }
      )
    },
    editMultipleDescriptions() {
      this.$modal.show(
        EditMultipleDescriptions,
        {
          productIds: this.selectedProductIds,
          callback: () => {
            setTimeout(() => this.refresh(), 500)
          }
        },
        {
          height: 'auto',
          width: 400,
          adaptive: true
        }
      )
    },
    removeItem(id) {
      const index = this.collection.products.findIndex(
        (element) => element.id === id
      )
      this.collections.products.splice(index, 1)
    },
    download(product) {
      window.location = `/api/v3/print-store/${this.rootStore.user.printStore.id}/download/${product.image}?fileName=${product.name}.pdf`
    },
    selectAll() {
      if (
        this.selectedProductIds.length === this.collection.products.length &&
        this.selectedProductIds.length > 0
      ) {
        this.selectedProductIds = []
      } else {
        this.selectedProductIds = []
        this.collection.products.forEach((prod) => {
          this.selectedProductIds.push(prod.id)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.products-container {
  position: relative;
}

.buttons {
  display: flex;
  justify-content: center;

  button {
    width: 105px;
  }
}

.admin-btns {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: -6px;

  > div {
    margin: 0 5px;
    flex-shrink: 0;
  }
}

.collection-text {
  padding-left: 12px;
  padding-right: 10px;
  margin-bottom: 0px;
}

.title-holder {
  flex-shrink: 0;
  min-height: 37px;
  display: flex;
  padding-bottom: 15px;
  padding-top: 11px;
  align-items: flex-end;
}
h1 {
  padding-left: 10px;
  margin-bottom: 0;
  font-size: 19px;
  font-weight: 500;
  color: var(--sub-color);
  flex-grow: 1;
  word-break: break-word;
}

p {
  padding-bottom: 10px;
  white-space: pre-line;
  line-height: normal;
}

.upload-btn-bottom {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.cart {
  ellipse {
    fill: var(--sub-color);
  }

  path {
    stroke: var(--sub-color);
    fill: var(--sub-color);
  }
}

.card-button-holder {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  .select {
    margin-left: 6px;
  }
}

.ico-cart {
  margin-left: 6px;
  margin-top: -6px;
}

.bottom-button-holder {
  position: absolute;
  right: 10px;
  bottom: 0px;
  z-index: 10;
}

.crumb-path {
  display: none;
}

.shake {
  animation: shake 1s infinite;
  cursor: grab;
}

@media only screen and (min-width: 940px) {
  .title-holder h1 {
    padding-left: 3px;
  }
  .back-btn {
    display: none;
  }

  .mob-h1 {
    display: none;
  }

  .crumb-path {
    color: var(--sub-color);
    font-weight: 400;
    line-height: 20px;
    list-style-type: none;
    flex-grow: 1;
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;

    .link {
      color: var(--sub-color);
      text-decoration: none;
      display: inline-block;
    }
  }

  .divider {
    height: 10px;
    margin: 0 9px 0 6px;

    g {
      fill: var(--sub-color);
    }
  }
}
</style>
